import './App.css';
import { Carousel } from './Component/Carousel';

function App() {
  return (
   <div className='main-div'>
    <Carousel/>
    </div>
  );
}

export default App;
